import { propertyOf } from '@/core/utils/typescript';
import { createSlice } from '@reduxjs/toolkit';
import { StickerState } from '@/shared/models';
import { getCleanedArticle } from '@/warehouse/helpers';
const initialState = {
    searchTerm: '',
    customerPackingSelectDialog: {
        open: false,
        selectedCustomerIds: [],
    },
    packingDetails: {
        currentBoxId: undefined,
        progressPercent: undefined,
        selectedItemIndex: -1,
        isPacking: false,
    },
    blockPackingStickerDialog: {
        open: false,
        data: undefined,
    },
    driverAssignmentDialog: {
        open: false,
        data: undefined,
    },
    createRealizationDialog: {
        open: false,
        data: undefined,
    },
};
const slice = createSlice({
    name: 'packing',
    initialState,
    reducers: {
        setSearchTerm: (state, action) => {
            state.searchTerm = action.payload;
        },
        openCustomerPackingSelectDialog: (state) => {
            state.customerPackingSelectDialog = {
                ...initialState.customerPackingSelectDialog,
                open: true,
            };
        },
        closeCustomerPackingSelectDialog: (state) => {
            state.customerPackingSelectDialog = initialState.customerPackingSelectDialog;
        },
        setCurrentBox: (state, action) => {
            state.packingDetails.currentBoxId = action.payload.deliveryBoxId;
        },
        setSelectedItemIndex: (state, action) => {
            state.packingDetails.selectedItemIndex = action.payload;
        },
        setIsPacking: (state, action) => {
            state.packingDetails.isPacking = action.payload;
        },
        // setSelectionBySearchTerm: (state, action: PayloadAction<{ items: PackingSticker[] | undefined; searchTerm: string }>) => {
        setSelectedItemIndexBySearchTerm: (state, action) => {
            const { items, searchTerm } = action.payload;
            const fieldToSearchBy = propertyOf('stickerId');
            if (!items?.length || !fieldToSearchBy || !searchTerm)
                return;
            const correctQrCode = getCleanedArticle(searchTerm);
            // It's necessary to locate only NOT packed items with `stickerId` strict equals to search term.
            // Data must not be filtered by `state` first since in this case the itemIndex will be 'broken' - it will be
            // an index of **filtered** items, but we need an index of **all** items.
            const itemIndex = items.findIndex((item) => item.state !== StickerState.Packed && item.stickerId === Number(correctQrCode));
            state.packingDetails.selectedItemIndex = itemIndex;
        },
        cleanPackingDetailsState: (state) => {
            state.packingDetails = initialState.packingDetails;
        },
        calculateProgressPercent: (state, action) => {
            const { stickers } = action.payload;
            if (!stickers) {
                state.packingDetails.progressPercent = 0;
            }
            else {
                const progress = stickers.reduce((result, { quantity, state }) => {
                    result.all += quantity;
                    if (state === StickerState.Packed)
                        result.done += quantity;
                    return result;
                }, { all: 0, done: 0 });
                state.packingDetails.progressPercent = progress.all === 0 ? 0 : Math.floor((progress.done / progress.all) * 100);
            }
        },
        changeCustomerMark: (state, action) => {
            const { selectedCustomerIds } = state.customerPackingSelectDialog;
            const { customerId, marked } = action.payload;
            if (marked) {
                if (!selectedCustomerIds.includes(customerId))
                    state.customerPackingSelectDialog.selectedCustomerIds = [...selectedCustomerIds, customerId];
            }
            else if (selectedCustomerIds.includes(customerId)) {
                state.customerPackingSelectDialog.selectedCustomerIds = selectedCustomerIds.filter((el) => el !== customerId);
            }
        },
        // TODO: to delete later if unused
        // markCustomer: (state, action: PayloadAction<number>) => {
        // 	if (state.customerPackingSelectDialog.selectedCustomerIds.includes(action.payload)) return;
        // 	state.customerPackingSelectDialog.selectedCustomerIds = [...state.customerPackingSelectDialog.selectedCustomerIds, action.payload];
        // },
        // unmarkCustomer: (state, action: PayloadAction<number>) => {
        // 	if (!state.customerPackingSelectDialog.selectedCustomerIds.includes(action.payload)) return;
        // 	state.customerPackingSelectDialog.selectedCustomerIds = state.customerPackingSelectDialog.selectedCustomerIds.filter(
        // 		(el) => el !== action.payload
        // 	);
        // },
        openBlockPackingStickerDialog: (state, action) => {
            state.blockPackingStickerDialog = {
                open: true,
                data: action.payload,
            };
        },
        closeBlockPackingStickerDialog: (state) => {
            state.blockPackingStickerDialog = initialState.blockPackingStickerDialog;
        },
        openDriverAssignmentDialog: (state, action) => {
            state.driverAssignmentDialog = {
                open: true,
                data: action.payload,
            };
        },
        closeDriverAssignmentDialog: (state) => {
            state.driverAssignmentDialog = initialState.driverAssignmentDialog;
        },
        openCreateRealizationDialog: (state, action) => {
            state.createRealizationDialog = {
                open: true,
                data: action.payload,
            };
        },
        closeCreateRealizationDialog: (state) => {
            state.createRealizationDialog = initialState.createRealizationDialog;
        },
    },
});
export const { actions: packingActions, reducer: packingStateReducer } = slice;
